import { HttpBackend } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CfgService } from "../../../../cfg/cfg.service";
import { ServerAddressesCfgService } from "src/app/util/serverAddressesCfg.service";

export class PendingOrdersFDCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class PendingOrdersFDKpiCfg {
  public pendingOrdersFD: PendingOrdersFDCfg;
  public urlPendingOrdersFD: string;
}

@Injectable()
export class PendingOrdersFDKpiCfgService extends CfgService<PendingOrdersFDKpiCfg> {
  json: any = {
    pendingOrdersFD: {
      summaryEndpointPattern: "%{DashboardApiUrl}/pendingordersfd/{0}",
      detailEndpointPattern: "%{DashboardApiUrl}/pendingordersfd/{0}/detail"
    },
    urlPendingOrdersFD: "%{OrdersFrontUrl}/orders/"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/pendingOrdersFDKpi.cfg.json`;
  }

  /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
